import React from "react";

import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";
import useStyles from "../../hooks/useStyles";

export default function Url(props: {
  store?: boolean;
  style?: React.CSSProperties;
}) {
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.web}
        style={useStyles.iconStore}
        alt={PlatformType.web}
      />
    </div>
  );
}
